import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBOcPYBCqPyz1za3B1D8FhNZ9oUN1_TBo0",
  authDomain: "roadvisiondata.firebaseapp.com",
  projectId: "roadvisiondata",
  storageBucket: "roadvisiondata.firebasestorage.app",
  messagingSenderId: "505717192876",
  appId: "1:505717192876:web:c0c0043800303e3232c709"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const storage = getStorage(app);
